import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class MaxCombinationsPercentValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const combos = stacking.getCheckedCombinations();

        let percent = 0;
        // @ts-ignore
        Object.values(combos).map((combo) => (percent += combo.exposure));

        if (100 < percent) {
            this.addError('Total exposures for selected stack combinations cannot be more than 100%.');
        }
    }
}

export default MaxCombinationsPercentValidator;
